import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { UserPrivilegeEnum } from '../../../../enums/rights/user-privilege.enum';
import { RLocation } from './r-location.action';
import { ResetStateDefaults } from '../../../base-action-class.model';

interface RLocationXsStateModel {
  viewLocation: string;
  createLocation: string;
  editLocation: string;
  deleteLocation: string;
}

const getDefaults = (): RLocationXsStateModel => ({
  viewLocation: null,
  createLocation: null,
  editLocation: null,
  deleteLocation: null
});

@State<RLocationXsStateModel>({
  name: 'rLocation',
  defaults: getDefaults()
})
@Injectable()
export class RLocationXsState {

  //region SELECTOR
  @Selector()
  static hasAnyCRUDLocationPrivilege(state: RLocationXsStateModel): boolean {
    return state.createLocation != null || state.editLocation != null || state.deleteLocation != null;
  }

  @Selector()
  static canViewLocation(state: RLocationXsStateModel): boolean {
    return state.viewLocation != null;
  }

  @Selector()
  static canCreateLocation(state: RLocationXsStateModel): boolean {
    return state.createLocation != null;
  }

  @Selector()
  static canEditLocation(state: RLocationXsStateModel): boolean {
    return state.editLocation != null;
  }

  @Selector()
  static canDeleteLocation(state: RLocationXsStateModel): boolean {
    return state.deleteLocation != null;
  }

  //endregion

  //region ACTIONS
  @Action(RLocation.SetLocationPrivileges)
  public setLocationPrivileges(ctx: StateContext<RLocationXsStateModel>, action: RLocation.SetLocationPrivileges) {
    const state = ctx.getState();
    const privileges = [...action.activeUserRightInfoDtoModel.locationPrivileges];

    //find user privilege data model
    const viewLocation = privileges.find(id => id === UserPrivilegeEnum.VIEW_LOCATION);
    const createLocation = privileges.find(id => id === UserPrivilegeEnum.CREATE_LOCATION);
    const editLocation = privileges.find(id => id === UserPrivilegeEnum.EDIT_LOCATION);
    const deleteLocation = privileges.find(id => id === UserPrivilegeEnum.DELETE_LOCATION);

    //set the state
    ctx.setState({
      ...state,
      viewLocation: viewLocation,
      createLocation: createLocation,
      editLocation: editLocation,
      deleteLocation: deleteLocation
    });
  }

  @Action(ResetStateDefaults)
  public resetDefaults(ctx: StateContext<RLocationXsStateModel>): void {
    ctx.setState({ ...getDefaults() });
  }
  //endregion

}
